export const GeneralOptions = {
  chart: {
    plotBackgroundColor: null,
    plotBorderWidth: null,
    plotShadow: false,
    type: "pie",
  },
  title: {
    text: "通識自主學習學分累計學分",
  },
  lang: {
    noData: "無資料",
  },
  noData: {
    style: {
      fontWeight: "bold",
      fontSize: "15px",
      color: "#303030",
    },
  },
  tooltip: {
    pointFormat: "{series.name}: <b>{point.y:.1f} 學分</b>",
  },
  accessibility: {
    point: {
      valueSuffix: "%",
    },
  },
  plotOptions: {
    pie: {
      showInLegend: true,
      allowPointSelect: true,
      cursor: "pointer",
      colors: [
        "#3B96F5",
        "#1559D6",
        "#244FED",
        "#1525D6",
        "#2318F0",
        "#16DFF5",
        "#1581D6",
        "#244FED",
      ],
      dataLabels: {
        enabled: true,
        format: "<b>{point.name}</b><br>{point.y:.1f} 學分",
        distance: -50,
        filter: {
          property: "percentage",
          operator: ">",
          value: 4,
        },
      },
    },
  },
  series: [
    {
      name: "學分",
      colorByPoint: true,
      data: [],
    },
  ],
};
